// `/c/{slug}/kpis/publications`: UX-A (ux pass 1.3) made Published a tab of the Scorecard, so the
// old page redirects (replace, query kept) to `/kpis/scorecard?view=published`. The screen is
// features/structure/publications-screen.tsx, rendered by the Scorecard's tab.
import { createRoute, redirect } from "@tanstack/react-router";
import { kpisRoute } from "./c.$slug.kpis";

export const publicationsRoute = createRoute({
  getParentRoute: () => kpisRoute,
  path: "publications",
  beforeLoad: ({ params, location }) => {
    throw redirect({
      to: "/c/$slug/kpis/scorecard",
      params,
      search: { ...(location.search as Record<string, string>), view: "published" } as never,
      replace: true,
    });
  },
});
